<template>
  <div>
    <Head title="Krijimi i shoferëve mbledhës" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/perdoruesit/shoferet-mbledhes">Shoferët mbledhës</Link>
      <span class="text-indigo-400 font-medium">/</span> Regjistro
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Emri" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Mbiemri" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Numri i telefonit" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.second_phone" :error="form.errors.second_phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Numri i telefonit(sekondar)" />

          <select-input v-model="form.region_id" :error="form.errors.country_id" :multiple="true" class="pb-8 pr-6 w-full lg:w-1/2" label="Regjioni">
            <option v-for="region in regions" :key="region.id" :value="region.id">{{ region.name }}</option>
          </select-input>

          <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/2" label="Adresa" />

          <file-input v-model="form.id_document_front" :error="form.errors.id_document_front" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Letërnjoftimi (Para)" />
          <file-input v-model="form.id_document_back" :error="form.errors.id_document_back" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Letërnjoftimi (Prapa)" />
          <file-input v-model="form.driving_license_front" :error="form.errors.driving_license_front" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Patent shoferi (Para)" />
          <file-input v-model="form.driving_license_back" :error="form.errors.driving_license_back" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Patent shoferi (Prapa)" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Regjistro shoferë</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Select2 from 'vue3-select2-component'
import FileInput from '@/Shared/FileInput'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Select2,
    FileInput
  },
  props: {
    regions: Array,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        second_phone: null,
        region_id: null,
        address: null,
        id_document_front: null,
        id_document_back: null,
        driving_license_front: null,
        driving_license_back: null
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/admin/perdoruesit/shoferet-mbledhes')
    },
  },
}
</script>
